export type EeapSlotOption = { value: string; label: string }

export type EeapSlot = {
  key: string
  label: string
  valueKind: 'text' | 'radio' | 'signature' | 'signatureDate'
  options?: EeapSlotOption[]
}

export const EEAP_SLOTS: EeapSlot[] = [
  { key: 'employeeName', label: 'Employee Name', valueKind: 'text' },
  {
    key: 'requestType',
    label: 'Request Type',
    valueKind: 'radio',
    options: [
      { value: 'equipment', label: 'Work Related Equipment' },
      { value: 'boots', label: 'Red Wing' },
      { value: 'greenHand', label: 'Green Hand Pack' },
    ],
  },
  { key: 'requestedItems', label: 'Requested Items', valueKind: 'text' },
  { key: 'currentAllowance', label: 'Current Allowance', valueKind: 'text' },
  { key: 'currentAdvanceBalance', label: 'Current Advance Balance', valueKind: 'text' },
  { key: 'totalRequestCost', label: 'Total Request Cost', valueKind: 'text' },
  { key: 'newAdvanceBalance', label: 'New Advance Balance', valueKind: 'text' },
  {
    key: 'eligible',
    label: 'Eligible?',
    valueKind: 'radio',
    options: [
      { value: 'yes', label: 'Yes' },
      { value: 'no', label: 'No' },
    ],
  },
  { key: 'eligibilityReason', label: 'Eligibility reason', valueKind: 'text' },
  {
    key: 'purchaseMethod',
    label: 'Purchase Method',
    valueKind: 'radio',
    options: [
      { value: 'company', label: 'Company' },
      { value: 'employee', label: 'Employee' },
    ],
  },
  {
    key: 'approved',
    label: 'Approved',
    valueKind: 'radio',
    options: [
      { value: 'asSubmitted', label: 'As submitted' },
      { value: 'withChanges', label: 'With changes' },
      { value: 'denied', label: 'Denied' },
    ],
  },
  { key: 'notes', label: 'Notes', valueKind: 'text' },
  { key: 'employeeSignature', label: 'Employee signature', valueKind: 'signature' },
  { key: 'employeeSignatureDate', label: 'Employee signature date', valueKind: 'signatureDate' },
  { key: 'adminSignature', label: 'Admin signature', valueKind: 'signature' },
  { key: 'adminSignatureDate', label: 'Admin signature date', valueKind: 'signatureDate' },
]

export const EEAP_SLOT_KEYS = EEAP_SLOTS.map((s) => s.key)

export function eeapSlotByKey(key: string) {
  return EEAP_SLOTS.find((s) => s.key === key) || null
}
